import { formatDDMMYYYY } from "../pages/Documents/forms/Html/LeagleDocuments/forms/commonfunctions";
import BASE from "../config";
import url from "../services/url";
import {
  capitalizeEachWord,
  formatDateDDMMYYYY,
} from "../utils/commonFunctions";

const useJoiningPrifilledData = () => {
  const filledJoiningData = (
    html,
    status,
    application,
    photo,
    sign,
    documentType,
    aadharDetails,
    documentDetails,
    form,
    metaData,
    acceptedForm
  ) => {
    if (form?.WEF && html.getElementById("wef") !== null) {
      html.getElementById("wef").innerText = `W.E.F : ${formatDDMMYYYY(
        new Date(form?.WEF)
      )}`;
    }

    if (form?.docNo && html.getElementById("doc_number") !== null) {
      html.getElementById("doc_number").innerText = `DOC NO : ${form?.docNo}`;
    }

    if (form?.revNo && html.getElementById("rev_number") !== null) {
      html.getElementById("rev_number").innerText = `REV. NO : ${form?.revNo}`;
    }

    if (form?.formName && html.getElementById("form_name") !== null) {
      html.getElementById("form_name").innerText = form?.formName;
    }

    if (html.getElementById("date") !== null) {
      html.getElementById("date").innerText =
        acceptedForm !== ""
          ? formatDateDDMMYYYY(new Date(acceptedForm))
          : formatDateDDMMYYYY(new Date());
    }
    if (html.getElementById("signature") !== null) {
      html.getElementById("signature").src =
        documentType === "S3" && BASE.storageType
          ? sign
          : url() + application?.candidateSignature[0]?.path;
    }
    if (html.getElementById("photo") !== null) {
      html.getElementById("photo").src =
        documentType === "S3" && BASE.storageType
          ? photo
          : url() + (application?.documetImage?.[0]?.path || application?.candidatePhoto?.[0]?.path);
    }
    if (html.getElementById("designation") !== null) {
      html.getElementById("designation").innerText =
        application?.trf?.position ? application?.trf?.position : "";
    }
    if (html.getElementById("email") !== null) {
      html.getElementById("email").innerText = application?.email;
    }
    if (html.getElementById("emp_id_last") !== null) {
      html.getElementById("emp_id_last").innerText = application?.empId;
    }
    if (html.getElementById("emp_id") !== null) {
      html.getElementById("emp_id").innerText = application?.empId;
    }
    if (html.getElementById("mobile_number") !== null) {
      html.getElementById("mobile_number").innerText = application?.mobileNo;
    }
    if (html.getElementById("name") !== null) {
      html.getElementById("name").innerText = capitalizeEachWord(
        aadharDetails?.aadharVerificationDetails?.data?.full_name
          ? aadharDetails?.aadharVerificationDetails?.data?.full_name
          : application?.name
      );
    }
    if (html.getElementById("name_1") !== null) {
      html.getElementById("name_1").innerText = capitalizeEachWord(
        aadharDetails?.aadharVerificationDetails?.data?.full_name
          ? aadharDetails?.aadharVerificationDetails?.data?.full_name
          : application?.name
      );
    }
    if (html.getElementById("date_of_joining") !== null) {
      html.getElementById("date_of_joining").innerText =
        !application?.DateOfJoining
          ? ""
          : formatDateDDMMYYYY(new Date(application?.DateOfJoining));
    }
    if (html.getElementById("address") !== null) {
      html.getElementById("address").innerText =
        metaData?.permanent_address &&
        metaData?.permanent_address?.replace(/\n/g, " ")?.trim();
    }
    if (html.getElementById("parents") !== null) {
      const fatherName =
        metaData?.father_name?.trim() ||
        aadharDetails?.aadharVerificationDetails?.data?.care_of
          ?.replace(/^[A-Za-z]+\/[A-Za-z]+:?\s+/i, "")
          .trim() ||
        "";
      html.getElementById("parents").innerText = fatherName;
    }
    if (html.getElementById("location") !== null) {
      html.getElementById("location").innerText = application?.workLocation;
    }

    const willingness = html.getElementById("willing_form");
    const checklist = html.getElementById("checklist_form");

    if (willingness && documentDetails) {
      for (var i = 0; i < willingness.elements.length; i++) {
        var element = willingness.elements[i];
        if (element.nodeName === "INPUT" && element.hasAttribute("name")) {
          element.value = documentDetails[element.getAttribute("name")];
          if (status !== null && status === false) {
            element.disabled = false;
          } else {
            element.disabled = true;
          }
        }
      }
    }

    if (checklist && documentDetails) {
      for (var i = 0; i < checklist.elements.length; i++) {
        var element = checklist.elements[i];
        if (element.nodeName === "INPUT" && element.hasAttribute("name")) {
          element.checked = documentDetails[element.getAttribute("name")];
          if (status !== null && status === false) {
            element.disabled = false;
          } else {
            element.disabled = true;
          }
        }
      }
    }

    return html;
  };

  return { filledJoiningData };
};

export default useJoiningPrifilledData;
